import { render, staticRenderFns } from "./MyFleetContent.vue?vue&type=template&id=2ef37d67"
import script from "./MyFleetContent.vue?vue&type=script&lang=ts"
export * from "./MyFleetContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports